module.exports = __webpack_public_path__ + "img/Group214.4e44f41f.png";